import { Route } from '@angular/router'
import { authGuard, permissionGuard } from '@baboor/baboor-auth'
import { PERMISSIONS } from '@baboor/baboor-models'
import { PageLayout, setLayout } from '@baboor/common-page-layouts'

export type TasksRoutes = {
    tasks: Route
}

export const tasksRoutes: TasksRoutes = {
    tasks: {
        path: 'dashboard/tasks',
        canActivate: [
            authGuard({ redirectTo: ['/login'] }),
            permissionGuard([PERMISSIONS.task.read], {
                redirectTo: ['/dashboard/home'],
            }),
        ],
        loadComponent: () =>
            import('../page-task/page-task.component').then(
                (m) => m.PageTaskComponent,
            ),
        resolve: { layout: setLayout(PageLayout.Default) },
    },
}
